// extracted by mini-css-extract-plugin
export default {"mpCopyToClipboard":"mp-copy-to-clipboard__ezp7l75G","copyInput":"copy-input__f4g8Ntv4","copyButton":"copy-button__nNPEAx20","fullWidth":"full-width__vAXacYdl"};